import styled, { css, keyframes } from 'styled-components';

const slideUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`;

const slideDown = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
`;

export const BottomSheetBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  opacity: 0;
  transition: opacity 0.3s ease-out;
  z-index: 999;

  ${props => props.isOpen && css`
    opacity: 1;
  `}
`;

export const BottomSheet = styled.div`
  width: 100%;
  max-height: 80%;
  background: white;
  border-radius: 20px 20px 0 0;
  padding: 20px;
  box-sizing: border-box;
  animation: ${props => props.isOpen ? slideUp : slideDown} 0.3s forwards;

  & .header {
    position: absolute;
    top: -50px;
    width: 92%;
    padding: 8px 12px;
    background: #ffedd1;
    border-radius: 8px;
    font-size: 12px;
    color: #4a4a4a;
    font-family: ${props => props?.fontFamily || 'inherit'};
    font-weight: 400;
  }
`;
